import { Trans } from 'react-i18next';

import IconPlus from '~icons/ic/round-plus';

import { HubTooltip } from '@adflow/frontend/ui-common';
import { theme } from '@adflow/frontend/ui-theme';

export function HistoryIconPlus() {
	return (
		<HubTooltip title={<Trans ns="common" i18nKey="Added" />}>
			<IconPlus
				css={{
					height: '1em',
					width: '1em',
					color: theme.colors.keywords.standard,
					'& path': {
						stroke: theme.colors.keywords.standard,
						strokeWidth: '2px',
					},
				}}
			/>
		</HubTooltip>
	);
}
